import { Helmet } from 'react-helmet-async';
import "./About.css";
import "../../ParafiaWizytowka.css"
import ImageRow from "../../components/ImageRow/ImageRow.js";
import Timeline from "./components/Timeline/Timeline.js";
import { about, peregrination, parishPeregrination, peregrinationImages, priests, parishPriests, vicars, patronImage, parishHistory } from "../../data/aboutData.js"
import ListSection from "./components/ListSection/ListSection.js";
import PeriodListSection from "./components/PeriodListSection/PeriodListSection.js";

const About = () => {
  return (
    <>
      <Helmet>
        <title>O Parafii – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
        <meta name="description" content="Historia parafii św. Urszuli Ledóchowskiej na Wrzosowiaku w Częstochowie. Dowiedz się o początkach parafii, proboszczach, wikariuszach i peregrynacji. Parafia erygowana w 1985 roku." />
        <meta name="keywords" content="historia parafii, parafia Wrzosowiak, św. Urszula Ledóchowska, proboszczowie, wikariusze, peregrynacja, Częstochowa" />
        <meta property="og:title" content="O Parafii – Parafia św. Urszuli Ledóchowskiej" />
        <meta property="og:description" content="Poznaj historię naszej parafii – od 1985 roku na Wrzosowiaku w Częstochowie. Sprawdź listę proboszczów, wikariuszy i informacje o peregrynacji." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="O Parafii – Parafia św. Urszuli Ledóchowskiej" />
        <meta name="twitter:description" content="Historia parafii św. Urszuli Ledóchowskiej w Częstochowie – proboszczowie, wikariusze, peregrynacja." />
      </Helmet>

      <section className="card">
        <img src={patronImage} alt="Kościół parafialny św. Urszuli Ledóchowskiej" className="image" />
        <p>{about}</p>

        <div className="parish-history">
          <h2 className="section-title">Historia parafii</h2>
          <Timeline items={parishHistory}/>
        </div>
        
        <PeriodListSection title="Proboszczowie" items={parishPriests}/>
        <ListSection title="Wikariusze" items={vicars}/>
        <ListSection title="Z parafii pochodzą księża" items={priests}/>

        <h2 className="section-title">Peregrynacja</h2>
        <p className="tab-text">{peregrination}</p>
        <ImageRow images={peregrinationImages} alt={"peregrynacja"}/>
        <p>{parishPeregrination}</p>
      </section>
    </>
  );
};

export default About;